import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import c3 from 'c3';
import * as d3 from 'd3';

@Component({
  selector: 'app-trending-chard-dialog',
  templateUrl: './trending-chard-dialog.component.html',
  styleUrls: ['./trending-chard-dialog.component.scss']
})
export class TrendingChardDialogComponent implements AfterViewInit {

  type: string;
  supplierName: string;
  chartSelector: any;
  public chartInstance: any;
  names: any[] = [];
  listData: any[] = [];
  gsl: string;
  axisX: string[] = [];

  @ViewChild('chartContainer') chartContainer: ElementRef;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TrendingChardDialogComponent>,
  ) {
    this.supplierName = data.supplier;
    this.type = data.name;
    this.gsl = data.gsl;
    this.names = Object.keys(this.data.data);
    this.names.pop();
    this.axisX = this.names.map(item => this.data.data[item].n);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.disposeChart();
    this.draw(this.data.data);
  }

  ngAfterViewInit() {
    this.draw(this.data.data);
  }

  ngOnDestroy() {
    d3.select(this.chartContainer.nativeElement).selectAll('*').remove();
  }

  private disposeChart() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
    this.chartSelector = null;
  }

  private draw(data) {
    this.names.forEach(item => {
      const object = {
        name: item,
        value: data[item].v ? data[item].v : 0,
        title: data[item].n ? data[item].n : ''
      };
      this.listData.push(object);
    });
    const min = this.sortValue(this.listData.slice())[0].value;
    if (min <= 0) {
      this.listData.forEach(item => item.value += Math.abs(min) + 10);
    }
    this.chartSelector = d3.select(this.chartContainer.nativeElement);

    const defaultConfig = {
      data: {
        x: 'x',
        columns: [
          this.transformXaxis(),
          this.transformYaxis(this.listData)
        ],
        type: 'area'
      },
      grid: {
        x: {
          lines: this.axisX.map(item => ({ value: item, position: 'middle' }))
        }
      },
      axis: {
        x: {
          show: true,
          type: 'category',
          padding: {
            right: 0,
            left: 0,
          },
          tick: {
            outer: false
          }
        },
        y: {
          show: false,
          padding: {
            top: 7,
            bottom: 7,
          },
          // min: this.getMinMaxValue(this.listData.slice()),
        }
      },
      tooltip: {
        contents: (d, defaultTitleFormat, defaultValueFormat, color) => {
          let text;
          const gsl = this.gsl ? this.gsl : this.type;
          const value = min > 0 ? this.listData[d[0].index].value : (this.listData[d[0].index].value - Math.abs(min) - 10).toFixed(2);
          text = `<div class="tool-tip">`;
          text += `<span class="text-center">` + this.listData[d[0].index].title + `</span></br>`;
          text += `<span> Parent Supplier Name/GSL: ` + '<span class="gslName">' + gsl +  `</span></span></br>`;
          text += `<span> ` + d[0].id + ': ' + value + `</span></br>`;

          return text + '</div>';
        }

      },
      legend: {
        show: false
      },
      bindto: this.chartContainer.nativeElement
    } as c3.ChartConfiguration;
    this.chartInstance = c3.generate(defaultConfig);
  }

  private transformXaxis() {
    return ['x'].concat(this.axisX);
  }

  private transformYaxis(data) {
    return [this.type].concat(data.map(item => item.value));
  }

  private sortValue(data) {
    return data.sort((a, b) => ( a.value - b.value));
  }

}
